import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, Form, Input, Spin } from 'antd';
import axios from 'axios';
import { MailOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { axiosErrorHandler, showSuccessNotification } from '../../swzutils';
import { validateEmail } from "../../swzutils/ValidationUtil";
import { useNavigate } from "react-router-dom";
import PublicPageLayout from "../PublicPageLayout";
const ForgotPasswordForm = () => {
    const navigate = useNavigate();
    const formRef = useRef(null);
    const [posting, setPosting] = useState(false);
    const requestPasswordResetEmail = (formValues) => {
        setPosting(true);
        axios.post('/admin/v1/authentication/forgot-password/' + encodeURIComponent(formValues.emailAddress), {}).then(() => {
            showSuccessNotification('A password email has been sent to the specified email address');
            navigate("/login");
        }).catch((error) => {
            axiosErrorHandler(error);
        }).finally(() => {
            setPosting(false);
        });
    };
    return (_jsx(Spin, { spinning: posting, delay: 500, children: _jsxs(Form, { layout: "vertical", ref: formRef, onFinish: requestPasswordResetEmail, children: [_jsx("p", { children: "Enter your email address. We'll send you an email with a link to reset your password." }), _jsx(Form.Item, { name: "emailAddress", rules: [
                        { required: true, message: 'Please input your email address.', },
                        { validator: validateEmail }
                    ], children: _jsx(Input, { prefix: _jsx(MailOutlined, {}), type: "email", placeholder: "Email Address" }) }), _jsx("div", { className: "divider", children: "\u00A0" }), _jsxs(Button, { type: "primary", size: "large", htmlType: "submit", children: [_jsx(MailOutlined, {}), "\u00A0 Send Email"] })] }) }));
};
const Page = () => (_jsx(PublicPageLayout, { heading: "Forgot Password", footer: _jsxs("a", { href: "#/login", children: [_jsx(QuestionCircleOutlined, {}), " Log in?"] }), children: _jsx(ForgotPasswordForm, {}) }));
export default Page;
